<footer class="footer">
  <div class="container-fluid">
    <nav class="pull-left">
      <ul>
        <li>
          <a href="#">
            Home
          </a>
        </li>
      </ul>
    </nav>
    <p class="copyright pull-right">
    </p>
  </div>
</footer>